export const GET_BUSINESS = 'GET_BUSINESS'
export const GET_BUSINESS_USERS = 'GET_BUSINESS_USERS'
export const SET_HUBSPOT_SETTINGS = "SET_HUBSPOT_SETTINGS";
export const CLEAR_BUSINESS_INFO = "CLEAR_BUSINESS_INFO";
export const HUBSPOT_CLOSED_VALUE = "HUBSPOT_CLOSED_VALUE";